import * as React from 'react';
// import Link from 'next/link'
import { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
// import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
// import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
// import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import Grid from "@mui/material/Grid";
import { ValidatorForm, TextValidator, SelectValidator } from 'react-material-ui-form-validator';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Alert from "@mui/material/Alert";
import axios from 'axios';
import './Login.css'
import { Base64 } from 'js-base64';
import { Modal, Input } from "@nextui-org/react";
import { api_url } from '../config';
import { SentimentDissatisfied } from '@mui/icons-material';
const theme = createTheme();
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "22rem",
  //   bgcolor: "#fff",
  border: "1px solid #f4f4f4",
  boxShadow: "0 10px 30px 0 rgb(8 0 255 / 5%)",
  padding: "13px 20px",
  backgroundColor: "#fff",
  borderRadius: "10px",
  justifyContent: "center",
  display: "flex",
  alignItems: "center",
};
const Registration = ({ setToken }) => {

  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [mobile, setMobile] = useState("");
  const [reg_no, setRegNo] = useState("");
  const [reg_mobile, setRegisteredMob] = useState("");
  const [loading, setLoading] = useState(false);
  const [otp, setOTP] = useState("");
  const [getotp, setGetOTP] = useState("");
  const [message, setMessage] = useState("");
  const [msg, setMsg] = useState(false);
  const [show, setShow] = useState(true);
  const [error, setError] = useState(false);
  const [val, setVal] = useState("");
  const [load, setLoad] = useState(false);
  const [visible, setVisible] = useState(false);
  const [err, setErr] = useState(false);
  const [userOtp,setuserOtp] = useState('');
  const [usergetOtp,setusergetOtp] = useState("");
  const [userShow,setuserShow] = useState(true);
  const [userloading,setUserLoading] = useState(false);
  const [userMsg,setuserMsg] = useState(false);
  const [userError,setUserError] = useState(false);
  const [resmsg,setResMsg] = useState(false);
  const [disable,setDisable] = useState(false);
  const [userdisable,setUserDisable] = useState(false);
  const handler = () => setVisible(true);
  const closeHandler = () => {
    setVisible(false);
    console.log("closed");
  };
  useEffect(() => {
    ValidatorForm.addValidationRule("isName", (value) => {
      if (value.length < 3) {
        return false;
      }
      return true;
    });

    ValidatorForm.addValidationRule("isRegistered", (value) => {
      if (value.length != 8) {
        return false;
      }
      return true;
    });


    ValidatorForm.addValidationRule("isMobile", (value) => {
      if (value.length !== 10) {
        return false;
      }
      if (value[0] === "0") {
        return false;
      }
      if (value[0] === "1") {
        return false;
      }
      if (value[0] === "2") {
        return false;
      }
      if (value[0] === "3") {
        return false;
      }
      if (value[0] === "4") {
        return false;
      }
      if (value[0] === "5") {
        return false;
      }
      if (
        value[1] == "9" &&
        value[2] == "9" &&
        value[3] == "9" &&
        value[3] == "9" &&
        value[4] == "9" &&
        value[5] == "9" &&
        value[6] == "9" &&
        value[7] == "9" &&
        value[8] == "9" &&
        value[9] == "9"
      ) {
        return false;
      }
      if (
        value[1] == "8" &&
        value[2] == "8" &&
        value[3] == "8" &&
        value[3] == "8" &&
        value[4] == "8" &&
        value[5] == "8" &&
        value[6] == "8" &&
        value[7] == "8" &&
        value[8] == "8" &&
        value[9] == "9"
      ) {
        return false;
      }
      if (
        value[1] == "7" &&
        value[2] == "7" &&
        value[3] == "7" &&
        value[3] == "7" &&
        value[4] == "7" &&
        value[5] == "7" &&
        value[6] == "7" &&
        value[7] == "7" &&
        value[8] == "7" &&
        value[9] == "9"
      ) {
        return false;
      }
      if (
        value[1] == "6" &&
        value[2] == "6" &&
        value[3] == "6" &&
        value[3] == "6" &&
        value[4] == "6" &&
        value[5] == "6" &&
        value[6] == "6" &&
        value[7] == "6" &&
        value[8] == "6" &&
        value[9] == "6"
      ) {
        return false;
      }
      return true;
    });
    ValidatorForm.addValidationRule("isOTP", (value) => {
      if (value.length !== 4) {
        return false;
      }
      return true;
    });
  }, [])

  const handleSubmit = async (event) => {

    event.preventDefault();
    // setOpen(true);

    try {
      setLoading(true);
      const { data: data2 } = await axios({
        url: "https://api-dot-reformexam.el.r.appspot.com/reliablekotaapp/get-otp-common",
        method: "post",
        responseType: "json",
        data: {
          mobile: mobile,
        },
      });
      console.log(data2)
      setMsg(true);
      const result = Base64.decode(data2.otp);
      setOTP(result);
      setShow(false);
      setMessage(data2.message)
      setDisable(true);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };
  console.log(message);


  const handleRegisteredUser = async () => {
   try{
    setUserLoading(true);
    setUserError(false);
    setuserMsg(false);
   if(userOtp===usergetOtp){
    const {data:obj} = await axios({
      url:  api_url + "/mission-vriksh-registered-user",
      method:'post',
      responseType:'json',
      data:{
        reg_mobile:reg_mobile
      },
    });
    if(obj.success==='ok'){
      setToken(obj.id);
    }
    else{
       setuserMsg(true);
    }
   }
   else{
    setuserMsg(false);
    setUserError(true);
   }
   }
   catch(e){
     console.log(e.message);
   }
   finally{
      setUserLoading(false);
   }
  }
  const handleSubmitRegisteredOtp = async()=>{
    try{
      setUserLoading(true);
      const { data: data2 } = await axios({
        url: "https://api-dot-reformexam.el.r.appspot.com/reliablekotaapp/get-otp-common",
        method: "post",
        responseType: "json",
        data: {
          mobile: reg_mobile,
        },
      });
      
      // setuserMsg(true);
      const result = Base64.decode(data2.otp);
      setuserOtp(result);
      setuserShow(false);
      setUserDisable(true);
    }
    catch(e){
      alert(e.message);
    }
    finally{
     setUserLoading(false);
    }
  }


  const handleSubmitOtp = async () => {
    try {
      setErr(false)
      setMsg(false);
      setLoading(true);
      if (otp === getotp) {
        const { data: obj } = await axios({
          url: api_url + "/mission-vriksh-registration",
          method: "post",
          responseType: "json",
          data: {
            name: name,
            mobile: mobile,
            address: address
          },
        });

        if (obj.success === "ok") {
          setToken(obj.id)
        }
        else {
          setMsg(true)
          setMessage(obj.message)
        }
      }
      else {
        setMsg(false)
        setErr(true)
      }
    }
    catch (e) {
      alert(e.message)
    }
    finally {
      setLoading(false);
    }
  }
  
  const handleResendOTP=async()=>{
    try {
      setLoading(true);
      const { data: data2 } = await axios({
        url: "https://api-dot-reformexam.el.r.appspot.com/reliablekotaapp/get-otp-common",
        method: "post",
        responseType: "json",
        data: {
          mobile: mobile,
        },
      });
      console.log(data2)
      
      const result = Base64.decode(data2.otp);
      // setResMsg(true);
      setMsg(true);
      setOTP(result);
      setShow(false);
      setMessage(data2.message)
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };
  const handleResendRegOTP=async()=>{
    try{
      setUserLoading(true);
      const { data: data2 } = await axios({
        url: "https://api-dot-reformexam.el.r.appspot.com/reliablekotaapp/get-otp-common",
        method: "post",
        responseType: "json",
        data: {
          mobile: reg_mobile,
        },
      });
      
      // setuserMsg(true);
      const result = Base64.decode(data2.otp);
      setuserOtp(result);
      setuserShow(false);
      
    }
    catch(e){
      alert(e.message);
    }
    finally{
     setUserLoading(false);
    }
  }
  

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        {/* <Box
          sx={{
            marginTop: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        > */}
        <div style={{ marginTop: "20px" }}>
          <Typography component="h1" variant="h5">
            Register here
          </Typography>
        </div>
        {msg && (
          <Alert severity="success">{message}</Alert>
        )}
        {err && <Alert severity='error'>Enter Correct OTP</Alert>}
        {loading && (
          <Alert severity="success">Submitting...</Alert>
        )}
        {/* {resmsg && <Alert severity='success'>{message}</Alert>} */}
        <ValidatorForm ref={useRef()} onSubmit={handleSubmit}>
          <Box sx={{ mt: 3 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} >
                <TextValidator
                  autoComplete={"off"}
                  margin="normal"
                  //style={{width:400}}
                  fullWidth
                  variant="outlined"
                  label="Name"

                  onChange={(e) => setName(e.target.value)}
                  name="name"
                  type="text"
                  validators={["required", "isName"]}
                  errorMessages={["Name is required", "Enter Name Correctly"]}
                  value={name}
                />
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  autoComplete={"off"}
                  margin="normal"
                  //style={{width:400}}
                  fullWidth
                  variant="outlined"
                  label="Mobile Number"
                  onChange={(e) => setMobile(e.target.value)}
                  name="mobile"
                  type="tel"
                  validators={["required", "isMobile"]}
                  errorMessages={[
                    "Mobile number is required",
                    "Enter Correct Number",
                  ]}
                  value={mobile}
                />
              </Grid>
              <Grid item xs={12}>
                <TextValidator
                  autoComplete={"off"}
                  margin="normal"
                  //style={{width:400}}
                  fullWidth
                  variant="outlined"
                  label="Address"
                  onChange={(e) => setAddress(e.target.value)}
                  name="address"
                  type="text"
                  validators={["required", "isName"]}
                  errorMessages={[
                    " Address is required",
                    "Enter Address Correctly",
                  ]}
                  value={address}
                />
              </Grid>

              {show && <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  style={{ backgroundColor: "#b11116" }}
                 disabled={disable}
                >
                  Get OTP
                </Button>

              </Grid>}
            </Grid>
          </Box>
        </ValidatorForm>
        <ValidatorForm ref={useRef()} onSubmit={handleSubmitOtp}>
          {!show &&
            <Box sx={{ mt: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextValidator
                    autoComplete={"off"}
                    margin="normal"
                    variant="outlined"
                    label="Enter OTP"
                    fullWidth
                    type="tel"
                    name="getotp"
                    value={getotp}
                    onChange={(e) => setGetOTP(e.target.value)}
                    validators={["required", "isOTP"]}
                    errorMessages={["OTP required", "Enter 4 digit OTP"]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "#b11116" }}
                  >
                    Submit OTP
                  </Button>
                  <p style={{ marginTop: "20px" }}>
            <a href="#" style={{ textDecoration: "none", color: "#000" }} onClick={handleResendOTP}> Resend OTP</a>
          </p>
                  {loading && (
                    <Alert severity="success">Submitting...</Alert>
                  )}
                  <br />
                </Grid>
              </Grid>
            </Box>
          }

        </ValidatorForm>

        {/* </Box> */}


        <Grid item xs={12}>
          <p style={{ marginTop: "20px" }}>
            <a href="#" style={{ textDecoration: "none", color: "#000" }} onClick={handler}> Already Registered!</a>
          </p>
        </Grid>
        <Modal
          closeButton
          blur
          aria-labelledby="modal-title"
          open={visible}
          onClose={closeHandler}
        >

          <Modal.Body>
            {/* {load && <Alert severity='success'>...Submitting</Alert>}
            {error && <Alert severity='error'>{val}</Alert>}
            <ValidatorForm ref={useRef()} onSubmit={handleRegisteredUser}>
              <TextValidator
                autoComplete={"off"}
                margin="normal"
                //style={{width:400}}
                fullWidth
                variant="outlined"
                label=" Registration No."

                onChange={(e) => setRegNo(e.target.value)}
                name="reg_no"
                type="tel"
                validators={["required", "isRegistered"]}
                errorMessages={["Registration No. is required", "Enter Registration No. Correctly"]}
                value={reg_no}
              />
              <TextValidator
                autoComplete={"off"}
                margin="normal"
                //style={{width:400}}
                fullWidth
                variant="outlined"
                label="Enter Registered Mobile Number"
                onChange={(e) => setRegisteredMob(e.target.value)}
                name="reg_mobile"
                type="tel"
                validators={["required", "isMobile"]}
                errorMessages={[
                  "Registered Mobile number is required",
                  "Enter Correct Registered Mobile Number",
                ]}
                value={reg_mobile}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                style={{ backgroundColor: "#b11116" }}
              >
                Submit
              </Button>
              
            </ValidatorForm> */}
            {userMsg && <Alert severity='error'>Enter Registered Mobile Number</Alert>}
            {userloading && <Alert severity='success'>...Submitting</Alert> }
            {userError && <Alert severity='error'>Enter Correct OTP</Alert>}
            <ValidatorForm ref={useRef()} onSubmit={handleSubmitRegisteredOtp}>
             <Box sx={{ mt: 1 }}>
              <Grid  container spacing={1}>
                <Grid item xs={12}>
              <TextValidator
                autoComplete={"off"}
                margin="normal"
                //style={{width:400}}
                fullWidth
                variant="outlined"
                label="Enter Registered Mobile Number"
                onChange={(e) => setRegisteredMob(e.target.value)}
                name="reg_mobile"
                type="tel"
                validators={["required", "isMobile"]}
                errorMessages={[
                  "Registered Mobile number is required",
                  "Enter Correct Registered Mobile Number",
                ]}
                value={reg_mobile}
              />
              </Grid>
               {userShow && <Grid item xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  style={{ backgroundColor: "#b11116" }}
                  disabled={userdisable}
                >
                  Get OTP
                </Button>

              </Grid>}
              </Grid>
              </Box>
            </ValidatorForm> 
            <ValidatorForm ref={useRef()} onSubmit={handleRegisteredUser}>
          {!userShow &&
            <Box sx={{ mt: 1 }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <TextValidator
                    autoComplete={"off"}
                    margin="normal"
                    variant="outlined"
                    label="Enter OTP"
                    fullWidth
                    type="tel"
                    name="getotp"
                    value={usergetOtp}
                    onChange={(e) => setusergetOtp(e.target.value)}
                    validators={["required", "isOTP"]}
                    errorMessages={["OTP required", "Enter 4 digit OTP"]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    style={{ backgroundColor: "#b11116" }}
                  >
                    Submit OTP
                  </Button>
                  <p style={{ marginTop: "20px",textAlign:"center" }}>
            <a href="#" style={{ textDecoration: "none", color: "#000" }} onClick={handleResendRegOTP}> Resend OTP</a>
          </p>
                  {/* {userloading && (
                    <Alert severity="success">Submitting...</Alert>
                  )} */}
                  <br />
                </Grid>
              </Grid>
            </Box>
          }

        </ValidatorForm>
             
          </Modal.Body>
        </Modal>

      </Container >
    </ThemeProvider >
  )
}

export default Registration;